import axios from "axios";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import DetailsSouvenirStar from "../../StarShowcase/Souvenir/DetailsSouvenirStar";

const SuperstarSouvenir = () => {
  const [checkSouviner, setCheckSouvenir] = useState({});
  const [loading, setloading] = useState(true);
  // const [status, setStatus] = useState(false);

  useEffect(() => {
    axios.get("/api/star/souviner/check").then((res) => {
      if (res.data.status === 200) {
        setCheckSouvenir(res.data?.getSouviner);
        // setStatus(res.data.action)
        setloading(false);
      }
      //  else {
      //     swal("error", "Data base Error", "error");
      // }
    });
  }, []);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          {checkSouviner ? (
            <DetailsSouvenirStar souviner={checkSouviner} />
          ) : (
            <div className="greetingsHeight d-flex justify-content-center align-items-center">
              <div className="text-center">
                <div className="box-open">
                  <i
                    style={{ color: "#ffc107" }}
                    className="fas fa-box-open"
                  ></i>
                </div>
                <div className="text-white">
                  <h3>No Data Here</h3>
                  <p>
                    <big>Create Souviner profile for you</big>
                  </p>
                  <p className="text-muted">
                    <small>
                      A default Souviner profile will enable the users <br /> to
                      understand and apply for Souviner videos
                    </small>
                  </p>
                </div>

                <Link to="/superstar/souvenir/create">
                  <button className="btn btn-warning mt-2 w-50">
                    Create New
                  </button>
                </Link>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SuperstarSouvenir;
